import { BaseTypeSchema } from "../BaseTypeSchema";
import { VariableType } from "../VariableType";

export class EntitySchema extends BaseTypeSchema
{
    public product: string;
    public table: string;
    public prefix: string;
    constructor(required: boolean, product: string, table: string, prefix: string)
    {
        super(VariableType.Entity, required);
        this.product = product;
        this.table = table;
        this.prefix = prefix;
    }
    getRegex(): RegExp
    {
        return new RegExp(`^${this.prefix}-.+&`);
    }
}